<template>
  <v-app id="alert-filters-app">
      <v-container class="alert-filter-container">
        <div>
          <table>
            <tr class="field-label">
              <td v-if="currentBreakdowns.status">
                <span class="field-label">Status</span>
              </td>
              <td v-if="currentBreakdowns.enabled">
                <span class="field-label">Enabled</span>
              </td>
              <td v-if="currentBreakdowns.type && internalUserOrEventsOptIn">
                <span class="field-label">Type</span>
              </td>
              <td v-if="currentBreakdowns.cdr">
                <span class="field-label">Metric</span>
              </td>
              <td v-if="currentBreakdowns.createdBy">
                <span class="field-label">Created By</span>
              </td>
              <td v-if="showButton">
              </td>
            </tr>
            <tr>
              <td v-if="currentBreakdowns.status">
                <v-btn-toggle
                    class="mr-8"
                    multiple
                    v-model="statusSelections"
                >
                  <v-tooltip
                      content-class="alert-state-tt"
                      color="var(--bad-color)"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="selection-button"
                          value="Critical"
                          :ripple="false"
                          v-on="on"
                      >
                        <span  class="alert-state-error"><i class="fas fa-exclamation-triangle fa-fw"></i> {{currentBreakdowns.status.Critical}}</span>
                      </v-btn>
                    </template>
                    <span>Critical</span>
                  </v-tooltip>

                  <v-tooltip
                      content-class="alert-state-tt"
                      color="var(--fair-color)"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="selection-button"
                            value="Warn"
                            :ripple="false"
                            v-on="on"
                        >
                          <span  class="alert-state-warn"><i class="fas fa-exclamation-square fa-fw"></i> {{currentBreakdowns.status.Warn}}</span>
                        </v-btn>
                    </template>
                    <span>Warn</span>
                  </v-tooltip>
                  <v-tooltip
                      content-class="alert-state-tt"
                      color="#0073b7"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="selection-button"
                          value="Info"
                          :ripple="false"
                          v-on="on"
                      >
                        <span  class="alert-state-info"><i class="fas fa-info-circle fa-fw"></i> {{currentBreakdowns.status.Info}}</span>
                      </v-btn>
                    </template>
                    <span>Info</span>
                  </v-tooltip>
                  <v-tooltip
                      content-class="alert-state-tt"
                      color="var(--good-color)"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="selection-button"
                          value="Clear"
                          :ripple="false"
                          v-on="on"
                      >
                        <span  class="alert-state-ok"><i class="fas fa-check-circle fa-fw"></i> {{currentBreakdowns.status.Clear}}</span>
                      </v-btn>
                    </template>
                  <span>Clear</span>
                  </v-tooltip>
                </v-btn-toggle>
              </td>
              <td v-if="currentBreakdowns.enabled">
                <v-btn-toggle
                    class="mr-8"
                    v-model="enabledSelection"
                >
                  <v-tooltip
                      color="var(--tooltip-background)"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="selection-button"
                          value="false"
                          :ripple="false"
                          v-on="on"
                      >
                        <span><i class="far fa-toggle-large-on fa-flip-horizontal fa-fw toggle-off-icon"></i> {{currentBreakdowns.enabled.no}}</span>
                      </v-btn>
                    </template>
                    <span>Disabled</span>
                  </v-tooltip>
                  <v-tooltip
                      color="var(--tooltip-background)"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="selection-button"
                          value="true"
                          :ripple="false"
                          v-on="on"
                      >
                        <span><i class="far fa-toggle-large-on fa-fw toggle-on-icon"></i> {{currentBreakdowns.enabled.yes}}</span>
                      </v-btn>
                    </template>
                    <span>Enabled</span>
                  </v-tooltip>
                </v-btn-toggle>
              </td>
              <td v-if="currentBreakdowns.type && internalUserOrEventsOptIn">
                <v-btn-toggle
                    class="mr-8"
                    v-model="typeSelection"
                >
                  <v-tooltip
                      color="var(--tooltip-background)"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="selection-button"
                          value="metrics"
                          :ripple="false"
                          v-on="on"
                      >
                        <span><i class="far fa-chart-line fa-fw"></i> {{currentBreakdowns.type.metric}}</span>
                      </v-btn>
                    </template>
                    <span>Metric Monitors</span>
                  </v-tooltip>
                  <v-tooltip
                      color="var(--tooltip-background)"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="selection-button"
                          value="events"
                          :ripple="false"
                          v-on="on"
                      >
                        <span><i class="far fa-rectangle-list fa-fw"></i> {{currentBreakdowns.type.event}}</span>
                      </v-btn>
                    </template>
                    <span>Event Monitors</span>
                  </v-tooltip>
                </v-btn-toggle>
              </td>
              <td v-if="currentBreakdowns.cdr">
                <v-btn-toggle
                    class="mr-8"
                    v-model="cdrSelection"
                >
                  <v-tooltip
                      color="var(--tooltip-background)"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="selection-button"
                          value="false"
                          :ripple="false"
                          v-on="on"
                      >
                        <span><i class="fas fa-water fa-fw"></i> {{currentBreakdowns.cdr.no}}</span>
                      </v-btn>
                    </template>
                    <span>Realtime Stream</span>
                  </v-tooltip>
                  <v-tooltip
                      color="var(--tooltip-background)"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="selection-button"
                          value="true"
                          :ripple="false"
                          v-on="on"
                      >
                        <span><i class="far fa-hourglass-half fa-fw"></i> {{currentBreakdowns.cdr.yes}}</span>
                      </v-btn>
                    </template>
                    <span>Call Records</span>
                  </v-tooltip>
                </v-btn-toggle>
              </td>
              <td v-if="currentBreakdowns.createdBy">
                <v-btn-toggle
                    class="mr-8"
                    v-model="createdBySelection"
                >
                  <v-tooltip
                      color="var(--tooltip-background)"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="selection-button"
                          value="me"
                          :ripple="false"
                          v-on="on"
                      >
                        <span><i class="fas fa-user fa-fw"></i> {{currentBreakdowns.createdBy.me}}</span>
                      </v-btn>
                    </template>
                    <span>Me</span>
                  </v-tooltip>
                  <v-tooltip
                      color="var(--tooltip-background)"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="selection-button"
                          value="others"
                          :ripple="false"
                          v-on="on"
                      >
                        <span><i class="fas fa-users fa-fw"></i> {{currentBreakdowns.createdBy.others}}</span>
                      </v-btn>
                    </template>
                    <span>Others</span>
                  </v-tooltip>
                </v-btn-toggle>
              </td>
              <td v-if="showButton">
                <button
                    class="add-monitor-btn btn btn-primary"
                    color="#4D52E5"
                    depressed
                    @click="(event) => showAddMoi(event)"
                >
                  <span class="add-monitor-text">Add Monitor</span><v-icon v-if="internalUserOrEventsOptIn" x-small class="add-monitor-btn-icon">fas fa-chevron-down</v-icon>
<!--                  todo use append slot in vuetify 3-->
                  <div v-if="showAddMoiMenu"
                       class="monitorTypeSelect">
                    <div
                        :class="{monitor: true, selected: false }"
                        class="add-monitor-menu-section"
                        @click="addMoi('metric')"
                    >
                      <i class="far fa-chart-line add-monitor-icon"></i>
                      <div class="add-monitor-menu-subsection">
                        <span class="add-monitor-header">Metric Monitor</span>
                        <span class="add-monitor-description">Compare metric values against thresholds.</span>
                      </div>
                    </div>
                    <v-divider></v-divider>
                    <div
                        :class="{monitor: true, selected: false }"
                        class="add-monitor-menu-section"
                        @click="addMoi('event')"
                    >
                      <i class="far fa-rectangle-list add-monitor-icon"></i>
                      <div class="add-monitor-menu-subsection">
                          <span class="add-monitor-header">Event Monitor <span class="new-beta badge">beta</span></span> 
                          <span class="add-monitor-description">Monitor when events occur.</span>
                        </div>
                    </div>
                    <v-divider></v-divider>
                      <div class="monitorTypeSupport"
                      >
                        Read our <a target="_blank" :href="brandingService.getSupportUrl('monitorTypes')">support article</a> on the monitor types<br>
                        with details and examples.
                    </div>
                  </div>
                </button>
              </td>
            </tr>
          </table>

          <v-spacer></v-spacer>

        </div>
      </v-container>
  </v-app>
</template>

<script>
  import _ from 'lodash';
  import BrandingService from '../../../../services/branding.service';
  import DataProvider from '../../../../app/data-framework/data-provider';
  import LoginService from '../../../../services/login.service';
  
  const PREF_KEY = 'ALERT_FILTERS';
  const EVENT = 'event';

  export default {
    name: 'alert-filters',
    components: {
    },
    props: {
      breakdowns: {
        type: Object,
        default: function () {
          return {};
        },
      },
      buttonEnabled: {
        type: Boolean,
        default: true
      },
      prefKey: {
        type: String,
        default: ''
      }
    },
    data: function() {
      return {
        brandingService: BrandingService,
        currentBreakdowns: this.breakdowns,
        statusSelections:[],
        enabledSelection:'',
        typeSelection:'',
        cdrSelection:'',
        createdBySelection:'',
        showAddMoiMenu:false,
        internalUserOrEventsOptIn: DataProvider.getInstance().isInternalUser() || LoginService.userObject.featureFlags.EventsOptIn , // to be removed
      };
    },
    computed: {
      showButton: function() {
        return this.buttonEnabled;
      },
      filters: function() {
        let self = this;
        let filter = [];
        if (self.statusSelections.length > 0) {
          filter.push({ field:'status', type:'in', value: _.difference(['Clear','Info','Warn','Critical','Unknown'], self.statusSelections)});
        }
        if (self.enabledSelection) {
          filter.push({ field:'enabled', type:'!=', value: 'true' === self.enabledSelection });
        }
        if (self.cdrSelection) {
          filter.push([{ field:'cdr', type:'!=', value: 'true' === self.cdrSelection},{ field:'category', type:'=', value: 'event'}]);
        }
        if (self.typeSelection) {
          if (self.typeSelection === 'events') {
            filter.push({ field:'category', type:'!=', value: 'event'});
          } else if (self.typeSelection === 'metrics') {
            filter.push({ field:'category', type:'=', value: 'event'});
          }
        }
        if (self.createdBySelection) {
          if (self.createdBySelection === 'me') {
            filter.push({ field:'createdBy', type:'!=', value: LoginService.userObject.userId });

          } else if (self.createdBySelection === 'others') {
            filter.push({ field:'createdBy', type:'=', value: LoginService.userObject.userId });
          }
        }
        return filter;
      }
    },
    created: function() {
      let self = this;
      let prefs = JSON.parse(window.sessionStorage.getItem(PREF_KEY+self.prefKey));
      if (!_.isEmpty(prefs)) {
        self.statusSelections = prefs.statusSelections || [];
        self.enabledSelection = prefs.enabledSelection || '';
        self.cdrSelection = prefs.cdrSelection || '';
        self.typeSelection = prefs.typeSelection || '';
        self.createdBySelection = prefs.createdBySelection || '';
      }
    },
    mounted(){
      let self = this;
    },
    methods: {
      showAddMoi: function(event) {
        let self = this;
        if (self.internalUserOrEventsOptIn) {
          self.showAddMoiMenu = true;
          event.stopImmediatePropagation();
          document.addEventListener('click', this.outsideClickListener);
        } else {
          self.addMoi();
        }
      },
      outsideClickListener: function() {
        let self = this;
        self.showAddMoiMenu = false;
        document.removeEventListener('click', this.outsideClickListener);
      },
      addMoi: function(type) {
        self.showAddMoiMenu = false;
        if (type === EVENT) {
          location.href = '#monitoring/moi/new?type=' + EVENT;
        } else {
          location.href = '#monitoring/moi/new';
        }
      },
    },
    watch: {
      breakdowns: {
        deep: true,
        immediate: true,
        handler: function(breakdowns) {
          this.currentBreakdowns = breakdowns;
        }
      },
      filters: {
        deep: true,
        handler: function(filters) {
          let self = this;
          window.sessionStorage.setItem(PREF_KEY+self.prefKey, JSON.stringify({
            statusSelections: self.statusSelections,
            enabledSelection: self.enabledSelection,
            cdrSelection: self.cdrSelection,
            typeSelection: self.typeSelection,
            createdBySelection: self.createdBySelection,
          }));

          self.$emit('alert-filters', filters);
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .alert-filter-container {
    max-width: unset!important;
    padding: 0;
    margin-bottom: 18px;
    margin-top: -2.5px;

    .add-monitor-btn {
      position: relative;
    }
  }

  .v-btn-toggle {
    border-radius: var(--border-radius);
  }

  .v-btn-toggle>.v-btn.v-btn.selection-button:last-child{
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }

  .v-btn-toggle>.v-btn.v-btn.selection-button:first-child {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
    border-left-width: 1px;
  }

  .v-btn-toggle>.v-btn.v-btn.selection-button {
    border-left-width: 0;
  }

  .v-btn-toggle > .v-btn.v-btn.selection-button {
    opacity: 1;
    padding: 0 7px;
  }

  .v-btn:not(.v-btn--round).v-size--default{
    height: 40px;
  }

  .v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
    height: 40px;
    min-width: 55px;
  }

  .v-btn.selection-button:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
    opacity: 0.05;
  }

  .v-btn.selection-button:not(.v-btn--text):not(.v-btn--outlined).v-btn--active span {
    opacity: 0.3;
  }

  .v-btn.selection-button:not(.v-btn--text):not(.v-btn--outlined):hover:before {
    opacity: 0.06;
  }


  .theme--light.v-btn.selection-button:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
    background-color: var(--filter-bg-color);
  }

  .add-monitor-text {
    font-size: 14px;
    padding-right: 6px;
  }

  .field-label {
    line-height: 20px;
    font-size: 14px;
    font-weight: 600;
    color: var(--filter-text-color);
  }

  .toggle-off-icon {
    color: var(--disabled-color);
  }
  .toggle-on-icon {
    color: var(--primary-btn-bg-color);
  }

  .monitorTypeSelect {
    font-size: 14px;
    font-weight: 600;
    position: absolute;
    left: 0;
    width: 295px;
    top: 38px;
    border: 1px solid #E1E1E1;
    border-radius: var(--border-radius);
    overflow: hidden;
    color: var(--soft-text-color);
    background: var(--panel-background);
    display: inline-block;
    text-align: left;
    z-index: 10000;

    .v-divider {
        margin: 0;
    }
    .monitor, .monitorTypeSupport {
      cursor: default;
      border-radius: 0px;
      margin: 0;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      text-align: center;
      padding: 10px 20px;
      
      &.add-monitor-menu-section {
        display: flex;
        flex-direction: row;
        
        .add-monitor-icon {
          color: var(--filter-text-color);
          margin: 4px 12px 0 0;
          font-size: 25px;
        }
        .add-monitor-menu-subsection {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          font-size: 14px;

          .add-monitor-header {
            font-weight: 700;
            margin: 0;
            padding: 4px 0px;
            .new-beta.badge {
              margin-top: -4px;
              margin-left: 8px;
            }
          }
          .add-monitor-description {
            line-height: 16px;
            text-wrap: wrap;
            text-align: left;
            font-weight: 500;
            margin: 0;
            text-indent: -1px;
            padding-left: 2px;
          }
        }
      }
      
      .new-beta.badge {
        width: 41px;
        height: 16px;
        background-color: #8085EA;
        line-height: 9px;
        border: #ffffff4d solid thin;
        color: #FFFFFF;
        font-style: italic;
        border-radius: 4px;
        text-align: center;
        font-weight: 700;
        font-size: 11px;
      }
    }
    .monitor {
      &:hover {
        background-color: var(--active-background);
      }
    }
    
  }

</style>
<style lang="scss">
  #alert-filters-app .v-application--wrap {
    min-height: 0;
  }

  .v-application#alert-filters-app .v-btn-toggle>.v-btn.v-btn.selection-button {
    border-radius: 0;
  }

  .v-application#alert-filters-app .v-btn-toggle>.v-btn.v-btn.selection-button:last-child{
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }

  .v-application#alert-filters-app .v-btn-toggle>.v-btn.v-btn.selection-button:first-child {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
  }

  .v-application#alert-filters-app .v-btn.selection-button:not(.v-btn--flat):not(.v-btn--outlined):not(.v-btn--disabled) .v-btn__content {
    color: var(--text-color);
  }

  .v-application#alert-filters-app .v-btn.selection-button .v-btn__content {
    font-size: 14px;
    font-weight: 500;
    font-family: "Forma DJR UI";
    letter-spacing: -0.01em;
  }
  
  .v-application#alert-filters-app .add-monitor-btn .v-icon.add-monitor-btn-icon {
    color: var(--primary-btn-color);
  }

  .v-application#alert-filters-app .v-btn.add-monitor-btn:not(.v-btn--round).v-size--default {
    padding: 0 30px;
  }

  .v-application#alert-filters-app .v-tooltip__content.alert-state-tt {
    text-transform: uppercase;
  }

  .v-application#alert-filters-app .v-tooltip__content {
    padding: 10px 15px;
    font-weight: bold;
    letter-spacing: unset;
    font-size: 12px;
    line-height: 9px;
    font-family: "Forma DJR UI";
    border-radius: 3px;
  }

  .v-application#alert-filters-app .v-tooltip__content:after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 8px 8px;
    border-top-color: inherit;
    border-bottom-color: inherit;
    border-left-color: transparent;
    border-right-color: transparent;
    display: block;
    width: 0;
    z-index: 1;
    top: -8px;
    left: 50%;
    transform: translate(-50%, 0px);
  }

</style>
